const areaFAQSetup = (() => {
    const faqItems = document.querySelectorAll('.institutional-section-faq > ul > li')

    faqItems.forEach((element) => {
      const headline = element.querySelector('.institutional-section-faq_question')
      const text = element.querySelector('.institutional-section-faq_text')

      headline.addEventListener('click', () => {
        headline.classList.toggle('active')
        text.classList.toggle('active')
      })
    })
  })()